import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import './FooterNavigation.css'
import { Logout } from '../../CommonFunction/Functions'
import { useDispatch, useSelector } from 'react-redux'
import { setToggleleftmenu } from '../../Redux/Slices/CommonLocalRedux/CommonSliceStorage'
import { SearchPopUp } from '../PopUp_Component/SearchPopUp'
import { setselectedtab } from '../../Redux/Slices/ScreenerRedux/CommonReduxSlices/ScreenerCommonSlice';
import Setting from '../PopUp_Component/Setting'
export const FooterNavigation = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [trufalse, settrufalse] = useState(true)
  const [serchmobileview, setserchmobileview] = useState(false)
  const [ShowsettingPopup, setShowsettingPopup] = useState(false)
  const togglemenu = useSelector(state => state.LocalValuesData.Toggleleftmenu)
  const ErrorStatus = useSelector(state => state.LocalValuesData.ErrorStatus)

  const mobilenavigation = () => {
    navigate(`/screener/domain`)
    dispatch(setselectedtab('domain'))
  }

  useEffect(() => {
    dispatch(setToggleleftmenu(trufalse))
  }, [trufalse])

  return (
    <>
      <ul className='footer_nav'>
        <li className={togglemenu == false ? 'active' : ''} onClick={() => settrufalse(!trufalse)}>
          <div className='icon-container'>
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="5" y="4" width="13" height="2" fill="#A0A3A7" />
              <rect x="5" y="9" width="13" height="2" fill="#A0A3A7" />
              <rect x="5" y="14" width="13" height="2" fill="#A0A3A7" />
            </svg>
          </div>
          <p>Menu</p>
        </li>
        <li onClick={mobilenavigation}>
          <div className='icon-container'>
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.125 5.90625C3.125 5.03601 3.4707 4.20141 4.08606 3.58606C4.70141 2.9707 5.53601 2.625 6.40625 2.625H15.5938C16.464 2.625 17.2986 2.9707 17.9139 3.58606C18.5293 4.20141 18.875 5.03601 18.875 5.90625V15.0938C18.875 15.964 18.5293 16.7986 17.9139 17.4139C17.2986 18.0293 16.464 18.375 15.5938 18.375H6.40625C5.53601 18.375 4.70141 18.0293 4.08606 17.4139C3.4707 16.7986 3.125 15.964 3.125 15.0938V5.90625ZM4.4375 7.875V15.0938C4.4375 15.6159 4.64492 16.1167 5.01413 16.4859C5.38335 16.8551 5.8841 17.0625 6.40625 17.0625H15.5938C16.1159 17.0625 16.6167 16.8551 16.9859 16.4859C17.3551 16.1167 17.5625 15.6159 17.5625 15.0938V7.875H4.4375Z" fill="#A0A3A7" />
            </svg>

          </div>
          <p>Screener</p>
        </li>
        <li className={serchmobileview == true ? 'active' : ''} onClick={() => setserchmobileview(true)}>
          <div className='icon-container'>
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.0618 12.2503H13.3706L13.1256 12.014C13.6724 11.3788 14.072 10.6305 14.2959 9.8227C14.5198 9.01493 14.5624 8.16767 14.4206 7.34153C14.0093 4.90903 11.9793 2.96653 9.52931 2.66903C8.66797 2.56007 7.79312 2.64958 6.9717 2.93074C6.15029 3.21189 5.40407 3.67722 4.79016 4.29114C4.17625 4.90505 3.71091 5.65126 3.42976 6.47268C3.14861 7.2941 3.05909 8.16895 3.16806 9.03028C3.46556 11.4803 5.40806 13.5103 7.84056 13.9215C8.66669 14.0633 9.51395 14.0208 10.3217 13.7969C11.1295 13.573 11.8778 13.1734 12.5131 12.6265L12.7493 12.8715V13.5628L16.4681 17.2815C16.8268 17.6403 17.4131 17.6403 17.7718 17.2815C18.1306 16.9228 18.1306 16.3365 17.7718 15.9778L14.0618 12.2503ZM8.81181 12.2503C6.63306 12.2503 4.87431 10.4915 4.87431 8.31278C4.87431 6.13403 6.63306 4.37528 8.81181 4.37528C10.9906 4.37528 12.7493 6.13403 12.7493 8.31278C12.7493 10.4915 10.9906 12.2503 8.81181 12.2503Z" fill="#A0A3A7" />
            </svg>
          </div>
          <p>Search</p>
        </li>
        <li className={ShowsettingPopup == true ? 'active' : ''} onClick={() => setShowsettingPopup(true)}>
          <div className='icon-container'>
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.125 5.90625C3.125 5.03601 3.4707 4.20141 4.08606 3.58606C4.70141 2.9707 5.53601 2.625 6.40625 2.625H15.5938C16.464 2.625 17.2986 2.9707 17.9139 3.58606C18.5293 4.20141 18.875 5.03601 18.875 5.90625V15.0938C18.875 15.964 18.5293 16.7986 17.9139 17.4139C17.2986 18.0293 16.464 18.375 15.5938 18.375H6.40625C5.53601 18.375 4.70141 18.0293 4.08606 17.4139C3.4707 16.7986 3.125 15.964 3.125 15.0938V5.90625ZM4.4375 7.875V15.0938C4.4375 15.6159 4.64492 16.1167 5.01413 16.4859C5.38335 16.8551 5.8841 17.0625 6.40625 17.0625H15.5938C16.1159 17.0625 16.6167 16.8551 16.9859 16.4859C17.3551 16.1167 17.5625 15.6159 17.5625 15.0938V7.875H4.4375Z" fill="#A0A3A7" />
            </svg>

          </div>
          <p>Setting</p>
        </li>
        <li onClick={Logout}>
          <div className='icon-container'>
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.125 5.90625C3.125 5.03601 3.4707 4.20141 4.08606 3.58606C4.70141 2.9707 5.53601 2.625 6.40625 2.625H15.5938C16.464 2.625 17.2986 2.9707 17.9139 3.58606C18.5293 4.20141 18.875 5.03601 18.875 5.90625V15.0938C18.875 15.964 18.5293 16.7986 17.9139 17.4139C17.2986 18.0293 16.464 18.375 15.5938 18.375H6.40625C5.53601 18.375 4.70141 18.0293 4.08606 17.4139C3.4707 16.7986 3.125 15.964 3.125 15.0938V5.90625ZM4.4375 7.875V15.0938C4.4375 15.6159 4.64492 16.1167 5.01413 16.4859C5.38335 16.8551 5.8841 17.0625 6.40625 17.0625H15.5938C16.1159 17.0625 16.6167 16.8551 16.9859 16.4859C17.3551 16.1167 17.5625 15.6159 17.5625 15.0938V7.875H4.4375Z" fill="#A0A3A7" />
            </svg>

          </div>
          <p>Logout</p>
        </li>
      </ul>
      {serchmobileview  && <SearchPopUp setserchmobileview={setserchmobileview} />}
      {ShowsettingPopup && <Setting setShowsettingPopup={setShowsettingPopup} />}

    </>
  )
}
